module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


//////////////////
// WEBPACK FOOTER
// external {"root":"reselect","commonjs2":"reselect","commonjs":"reselect","amd":"reselect","umd":"reselect"}
// module id = 6
// module chunks = 0